module.exports = __webpack_public_path__ + "static/img/solution2.1405edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution2.png
// module id = c3+U
// module chunks = 1